module.exports = __webpack_public_path__ + "static/media/whiteReports.65103665.svg";